import axios from "axios";
import { API_URL, authHeader } from "./api";

const ENDPOINT_URL = API_URL + "hotel/billing";

class BillingService {
  getBillingInfo() {
    return axios.get(ENDPOINT_URL, { headers: authHeader() });
  }

  createSetupIntent() {
    return axios.post(
      `${ENDPOINT_URL}/setup-intent`,
      {},
      { headers: authHeader() },
    );
  }

  updatePaymentMethod(paymentMethodId) {
    return axios.post(
      `${ENDPOINT_URL}/payment-method`,
      { paymentMethodId },
      { headers: authHeader() },
    );
  }

  // Self-managed renewal: toggle autopay on the subscription.
  setAutopay(enabled) {
    return axios.put(
      `${ENDPOINT_URL}/autopay`,
      { enabled },
      { headers: authHeader() },
    );
  }

  // Get the open renewal invoice's hosted URL to pay on-session.
  retry() {
    return axios.post(`${ENDPOINT_URL}/retry`, {}, { headers: authHeader() });
  }
}

export default new BillingService();
